import { Suspense, useMemo } from "react"
import { I18nextProvider } from "react-i18next"
import { Outlet } from "react-router-dom"
import { ConfigProvider, App as AppAntd } from "antd"
import en_US from "antd/es/locale/en_US"
import jp_JP from "antd/es/locale/ja_JP"
import i18n from "@locales"
import { APP_LOCALE, defaultThemeConfigs, signageThemeConfigs } from "@constants"
import { legacyLogicalPropertiesTransformer, StyleProvider } from "@ant-design/cssinjs"

const getAntdLocale = () => {
  switch (APP_LOCALE) {
    case "en":
      return en_US
    default:
      return jp_JP
  }
}

export function BaseProvider({ children, isSignage = false }) {
  const transformers = isSignage ? [legacyLogicalPropertiesTransformer] : []

  return (
    <I18nextProvider i18n={i18n}>
      <StyleProvider autoClear hashPriority={isSignage ? "high" : "low"} transformers={transformers}>
        {children}
      </StyleProvider>
    </I18nextProvider>
  )
}
const locale = getAntdLocale()

function getLayout(originalTheme) {
  return () => {
    const primaryColor = ""
    const themeWithPrimaryColor = useMemo(() => {
      const { theme } = originalTheme

      if (primaryColor) {
        theme.token.colorPrimary = primaryColor
      }

      return { ...theme, token: { ...theme.token } }
    }, [primaryColor])

    return (
      <ConfigProvider {...originalTheme} locale={locale} theme={themeWithPrimaryColor}>
        <AppAntd>
          <Suspense>
            <Outlet />
          </Suspense>
        </AppAntd>
      </ConfigProvider>
    )
  }
}

export const RootLayout = getLayout(defaultThemeConfigs)

export const SignageRootLayout = getLayout(signageThemeConfigs)
